import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, FormGroup } from "reactstrap";

export default function ModalForm({
    isOpen,
    toggle,
    title,
    formFields,
    selectedRow,
    handleInputChange,
    onSubmit,
    onCancel,
    uniqBeatName,
}) {
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody>
                {formFields.map(({ id, label, name, type, readOnly, required, options, defaultChecked }) => (
                    <FormGroup key={name} className="d-flex align-items-center">
                        {type === "checkbox" ? (
                            <div className="d-flex align-items-center w-100">
                                <div style={{ width: '25%' }}></div>
                                <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
                                    <Input
                                        type="checkbox"
                                        name={name}
                                        id={id}
                                        checked={!!(selectedRow && typeof selectedRow[name] !== 'undefined' ? selectedRow[name] : defaultChecked)}
                                        onChange={e => handleInputChange({ target: { name, value: e.target.checked } })}
                                        className="mr-2"
                                        readOnly={readOnly}
                                        style={{ width: '18px', height: '18px' }}
                                    />
                                    <Label for={name} className="mb-0 ml-2" style={{ userSelect: 'none', cursor: 'pointer' }}>{label}</Label>
                                </div>
                            </div>
                        ) : type === "select" ? (
                            <div className="d-flex align-items-center w-100">
                                <Label for={name} className="mr-2 w-25">
                                    {label}
                                </Label>
                                <Input
                                    type="select"
                                    name={name}
                                    id={id}
                                    value={selectedRow ? selectedRow[name] : ""}
                                    onChange={handleInputChange}
                                    className="w-75"
                                    required={required}
                                >
                                    <option value="">Select</option>
                                    {(options || (uniqBeatName && uniqBeatName.map(b => ({ label: b, value: b }))) || []).map(opt => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </Input>
                            </div>
                        ) : (
                            <div className="d-flex align-items-center w-100">
                                <Label for={name} className="mr-2 w-25">
                                    {label}
                                </Label>
                                <Input
                                    type={type}
                                    name={name}
                                    id={id}
                                    value={selectedRow ? selectedRow[name] : ""}
                                    onChange={handleInputChange}
                                    className="w-75"
                                    readOnly={readOnly}
                                    required={required}
                                    autoComplete="off"
                                />
                            </div>
                        )}
                    </FormGroup>
                ))}
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onSubmit}>
                    Update
                </Button>
                <Button color="secondary" onClick={onCancel}>
                    Reset
                </Button>
            </ModalFooter>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/ModalForm.js